import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
const SvgComponent = props => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={26}
    viewBox="0 0 26 26"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#2D27F6'}
      d="M20 .619c-.5-.04-.99.13-1.34.48l-9.46 9.46a7.45 7.45 0 0 0-2.2 5.31v.57a2.5 2.5 0 0 0 2.5 2.5h.57c2 0 3.89-.78 5.31-2.2l9.46-9.46c.35-.35.53-.84.48-1.34-.24-2.83-2.5-5.09-5.32-5.32Zm-5.8 14.94a5.81 5.81 0 0 1-4.13 1.71H9.5c-.46 0-.83-.37-.83-.83v-.57c0-1.56.61-3.03 1.71-4.13l9.48-9.48.43.08a4.17 4.17 0 0 1 3.31 3.31l.08.43-9.48 9.48Z"
    />
    <Path
      fill={props.fill || '#2D27F6'}
      d="M7.84 3.93H6.17C2.95 3.93.33 6.55.33 9.77v10c0 3.22 2.62 5.84 5.84 5.84h10c3.22 0 5.84-2.62 5.84-5.84V18.1c0-.46-.37-.83-.83-.83-.46 0-.83.37-.83.83v1.67c0 2.3-1.87 4.17-4.17 4.17h-10c-2.3 0-4.17-1.87-4.17-4.17v-10c0-2.3 1.87-4.17 4.17-4.17h1.67c.46 0 .83-.37.83-.83 0-.46-.37-.83-.83-.83l-.01-.01Z"
    />
  </Svg>
);
export default SvgComponent;
